module.exports = __webpack_public_path__ + "static/media/37-6.01e24278.mp3";